import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, Stack, IconButton, Popover, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useResponsive from 'hooks/useResponsive';

// ----------------------------------------------------------------------

const LANGS = {
  uz: {
    value: 'uz',
    label: 'UZB',
    icon: '/assets/icons/ic_flag_uz.svg'
  },
  kr: {
    value: 'kr',
    label: 'КИРИЛ',
    icon: '/assets/icons/ic_flag_ru.svg'
  },
  ru: {
    value: 'ru',
    label: 'РУС',
    icon: '/assets/icons/ic_flag_ru.svg'
  }
};

const LangOption = ({ icon, label, showLabel = true }) => (
  <Stack direction="row" alignItems="center" spacing={showLabel ? 1.5 : 0}>
    <Box
      component="img"
      src={icon}
      alt={label}
      sx={{ width: 24, height: 18, borderRadius: 0.5, objectFit: 'cover' }}
    />
    {showLabel ? (
      <Typography variant="body2" fontWeight={600}>
        {label}
      </Typography>
    ) : null}
  </Stack>
);

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { i18n } = useTranslation();
  const isMobile = useResponsive('down', 'sm');
  const [open, setOpen] = useState(null);
  const [lang, setLang] = useState(() => localStorage.getItem('i18nextLng') || i18n.language || 'kr');

  const currentLang = LANGS[lang] || LANGS.kr;

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleClick = (e) => {
    const target = e.target.closest('[data-index]');
    const index = target?.dataset?.index;

    if (!index) {
      return;
    }
    localStorage.setItem('i18nextLng', index);
    setLang(index);
    i18n.changeLanguage(index);
    handleClose();
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          padding: '4px 8px',
          borderRadius: 1,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}>
        <LangOption icon={currentLang.icon} label={currentLang.label} showLabel={!isMobile} />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75
            }
          }
        }}>
        <Stack spacing={0.75} onClick={handleClick}>
          {Object.values(LANGS).map((option) => (
            <MenuItem data-index={option.value} key={option.value}>
              <LangOption icon={option.icon} label={option.label} showLabel />
            </MenuItem>
          ))}
        </Stack>
      </Popover>
    </>
  );
}
